/*
  Button loading state — Concept-style pulsing dots.

  Opt a button in with `data-loader`. When its form submits — natively
  (newsletter, comments, cart checkout) or intercepted by the cart drawer's
  AJAX add — the label fades out and three pulsing dots fade in, driven by
  aria-busy="true" + the .btn-loader rules in base.css.

  The dots markup is injected lazily at start() time, so content re-rendered
  by the Section Rendering API (e.g. the cart drawer body) never loses its
  loader. Programmatic use for AJAX flows:

    theme.buttonLoader.start(btn) / stop(btn) / stopAll()

  stopAll() also runs on pageshow so bfcache-restored pages (back button from
  checkout) never come back with a stuck spinner.
*/
(function () {
  'use strict';

  function ensureDots(button) {
    if (button.querySelector('.btn-loader')) return;
    var loader = document.createElement('span');
    loader.className = 'btn-loader';
    loader.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 3; i++) loader.appendChild(document.createElement('span'));
    button.appendChild(loader);
  }

  function start(button) {
    if (!button) return;
    ensureDots(button);
    button.setAttribute('aria-busy', 'true');
  }

  function stop(button) {
    if (button) button.removeAttribute('aria-busy');
  }

  function stopAll() {
    document.querySelectorAll('[data-loader][aria-busy="true"]').forEach(function (button) {
      button.removeAttribute('aria-busy');
    });
  }

  window.theme = window.theme || {};
  window.theme.buttonLoader = { start: start, stop: stop, stopAll: stopAll };

  // Delegated: any opted-in submit button lights up when its form submits.
  // preventDefault (the cart drawer's AJAX intercept) doesn't stop this from
  // firing — the drawer calls stopAll() when its request settles.
  document.addEventListener('submit', function (event) {
    var button =
      (event.submitter && event.submitter.closest('[data-loader]')) ||
      (event.target.querySelector && event.target.querySelector('[type="submit"][data-loader]'));
    if (button) start(button);
  });

  // Only on bfcache restores — pageshow also fires on the initial load, and
  // clearing there would wipe a loader started before the page finished.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) stopAll();
  });
})();
